/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProcessState } from './processState.model';
import { ProcessEntityType } from './processEntityType.model';


export interface ProcessDto { 
    entityId?: number;
    entityType?: ProcessEntityType;
    hasFuture?: boolean;
    id?: number;
    isRunning?: boolean;
    isSubmitted?: boolean;
    projectKey?: string;
    state?: ProcessState;
    username?: string;
}
export namespace ProcessDto {
}


